import { render, staticRenderFns } from "./MainTopbar.vue?vue&type=template&id=ddd8be60&scoped=true&"
import script from "./MainTopbar.vue?vue&type=script&lang=js&"
export * from "./MainTopbar.vue?vue&type=script&lang=js&"
import style0 from "./MainTopbar.vue?vue&type=style&index=0&id=ddd8be60&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ddd8be60",
  null
  
)

export default component.exports